import { render, staticRenderFns } from "./TextareaInput.vue?vue&type=template&id=1434df26&scoped=true"
import script from "./TextareaInput.vue?vue&type=script&lang=js"
export * from "./TextareaInput.vue?vue&type=script&lang=js"
import style0 from "./TextareaInput.vue?vue&type=style&index=0&id=1434df26&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1434df26",
  null
  
)

export default component.exports